export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/5860effcda061f4f05feb4a92be5a34c.svg";